import { render, staticRenderFns } from "./MenuBottom.vue?vue&type=template&id=060dfadc&"
import script from "./MenuBottom.vue?vue&type=script&lang=js&"
export * from "./MenuBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports